const date = function (value, type) {
    if (!value) {
        return 'no data';
    }

    let options = {};
    if (type === 'brief') {
        options = {
            day: 'numeric',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        };
    } else if (type === 'short') {
        options = {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        };
    } else if (type === 'day-only') {
        options = {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        };
    } else if (type === 'only-time') {
        options = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        };
    } else {
        options = {
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            month: 'long',
            timeZoneName: 'short',
            weekday: 'long',
            year: 'numeric',
        };
    }

    const dateObj = new Date(value);
    if (Number.isNaN(dateObj.getTime())) {
        return 'no data';
    }

    let dateStr =
        type === 'only-time'
            ? dateObj.toLocaleTimeString('en', options)
            : dateObj.toLocaleString('en', options);

    if (type === 'no-time') {
        const substringCut = 6;
        dateStr = dateStr.substring(0, dateStr.length - substringCut);
    }

    if (type === 'day-only') {
        const dateArr = dateStr.split(',');
        dateStr = [dateArr[0], dateArr[1]].join(',');
    }

    return dateStr;
};

export default date;
